module.exports = __webpack_public_path__ + "img/rocket.9bd10298.png";